export const categories = [
  {
    slug: 'shiyong-jiaocheng',
    name: '使用教程',
    description: '黄油相机详细使用教程，从入门到精通',
    icon: 'ri-book-open-line',
    articleCount: 24,
  },
  {
    slug: 'jiqiao-fenxiang',
    name: '技巧分享',
    description: '黄油相机实用技巧与小窍门分享',
    icon: 'ri-lightbulb-line',
    articleCount: 18,
  },
  {
    slug: 'gengxin-rizhi',
    name: '更新日志',
    description: '黄油相机最新版本更新内容与功能介绍',
    icon: 'ri-refresh-line',
    articleCount: 12,
  },
  {
    slug: 'changjian-wenti',
    name: '常见问题',
    description: '黄油相机常见问题解答与故障排除',
    icon: 'ri-question-line',
    articleCount: 15,
  },
  {
    slug: 'muban-tuijian',
    name: '模板推荐',
    description: '精选黄油相机热门模板与排版推荐',
    icon: 'ri-layout-masonry-line',
    articleCount: 20,
  },
  {
    slug: 'lvjing-jiaocheng',
    name: '滤镜教程',
    description: '黄油相机滤镜使用指南与调色技巧',
    icon: 'ri-contrast-2-line',
    articleCount: 16,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};